// extracted by mini-css-extract-plugin
export default {"thumbnailBatch":"render-selection-items-module--thumbnail-batch--S9Cs4","closeIcon":"render-selection-items-module--close-icon--S6LBr"};